
import { updateUserAPI } from "./api";

export const updateUser = (data) => {
    return new Promise((resolve, reject) => {
        updateUserAPI(data)
            .then((res) => {
                resolve(res);
            })
            .catch((err) => {
                reject(err);
            });
    });
};
